import React, { useState } from 'react'
import { TextField, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import FormInputGroup from '../../UI/FormInputGroup'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import {
  StyledWidget,
  StyledDatePicker,
  MainContainer,
  TopContainer,
  FlexContainer,
  ButtonContainer,
  ButtonWrapper,
  SelectWrapper,
  ErrorText
} from './styles'

const CreateReport = ({ createReportModalToggle, projects, hauls, drivers, createReport }) => {
  const [step, setStep] = useState(0) //0, 1,
  const [selectedDrivers, setSelectedDrivers] = useState([])
  const [haulIdOptions, setHaulIdOptions] = useState([])
  const [driversList, setDriversList] = useState(
    drivers.map((item, i) => {
      return { value: item._id, label: `${item.firstName} ${item.lastName}` }
    })
  )

  const projectOptions = projects.map((item, i) => {
    return { value: item._id, label: item.projectName }
  })

  const handleBackOrCancelClick = () => {
    if (step !== 0) {
      return setStep(step - 1)
    }
    if (step === 0) {
      return createReportModalToggle()
    }
  }

  const handleNextButtonClick = (values, errors, setFieldError) => {
    if (step === 0) {
      if (!values.name || !values.startDateTime || !values.endDateTime) {
        return
      }

      setStep(step + 1)
    }
    if (step === 1) {
      submitCreateReport(values)
    }
  }

  const submitCreateReport = values => {
    const payload = {
      ...values
    }
    payload.drivers = values.drivers.map(item => item.value)
    payload.hauls = values.hauls.map(item => item.value)
    payload.projects = values.projects.map(item => item.value)

    createReport(payload)
    createReportModalToggle()
  }

  const handleHaulIdChange = (e, setFieldValue, values) => {
    const haul = hauls.find(item => item._id === e.value)
    const project = projects.find(item => haul.project._id === item._id)
    setFieldValue('project', { value: project._id, label: project.projectName }, false)
    setFieldValue('haulId', e, false)
  }

  const handleProjectChange = (e, setFieldValue, values) => {
    if (values.hauls && values.hauls.length > 0) {
      return
    }
    if (values.projects && values.projects.find(item => item.value === e.value)) {
      const projectList = values.projects.filter(item => item.value !== e.value)
      setFieldValue(
        'projects',
        values.projects.filter(item => item.value !== e.value)
      )
      console.log(projectList)
      if (projectList.length === 0) {
        setHaulIdOptions([])
        setFieldValue(
          'haulId',
          {
            value: '',
            label: ''
          },
          false
        )
      } else {
        setHaulIdOptions(
          hauls
            .filter(item => projectList.includes(item.projectId))
            .map((item, i) => {
              return {
                value: item._id,
                label: `${item.pickUpSite.siteName} to ${item.dropOffSite.siteName} - ${item.haulId}`
              }
            })
        )
      }
    } else {
      setFieldValue('projects', [...values.projects, e])
      setHaulIdOptions(
        hauls
          .filter(item => values.projects.includes(item.projectId))
          .map((item, i) => {
            return {
              value: item._id,
              label: `${item.pickUpSite.siteName} to ${item.dropOffSite.siteName} - ${item.haulId}`
            }
          })
      )
    }

    setHaulIdOptions(
      hauls
        .filter(item => item.projectId === e.value)
        .map((item, i) => {
          return {
            value: item._id,
            label: `${item.pickUpSite.siteName} to ${item.dropOffSite.siteName} - ${item.haulId}`
          }
        })
    )
  }

  const getBannerText = () => {
    switch (step) {
      case 0:
        return 'Enter the name and date range'
      case 1:
        return 'Include the following information'
      default:
        break
    }
  }

  return (
    <CreateNewModal
      title="Create Report"
      handleCloseModal={createReportModalToggle}
      bannerText={getBannerText()}
      bannerTextRight={`Step ${step + 1} of 2`}
    >
      <Formik
        enableReinitialize={false}
        initialValues={{
          name: '',
          description: '',
          startDateTime: '',
          endDateTime: '',
          companies: [],
          projects: [],
          hauls: [],
          drivers: []
        }}
        validationSchema={DispatchSchema}
        handleSubmit={e => console.log(e)}
        onSubmit={values => {
          submitCreateReport(values)
        }}
        render={({
          values,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          submitForm,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          touched,
          setFieldError
        }) => (
          <form>
            <StyledWidget id="report-form">
              {step === 0 && (
                <MainContainer>
                  <TopContainer>
                    <FormInputGroup horizontal>
                      <div>
                        <TextField
                          className="fullWidthInputBox"
                          label="Name"
                          name="name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                        />
                        <ErrorMessage name="name" render={msg => <ErrorText>{msg}</ErrorText>} />
                      </div>
                    </FormInputGroup>

                    <FormInputGroup horizontal>
                      <TopContainer>
                        <TextField
                          className="fullWidthInputBox"
                          label="Description"
                          name="description"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                        />
                        <ErrorMessage
                          name="description"
                          render={msg => <ErrorText>{msg}</ErrorText>}
                        />
                      </TopContainer>
                    </FormInputGroup>

                    <div style={{ padding: '20px 0' }}>
                      <FormInputGroup>
                        <div style={{ marginBottom: '0.5rem' }}>
                          <span className="content-title">START DATE</span>
                        </div>
                        <StyledDatePicker
                          selectsStart
                          className="uik-input__input fullWidthInputBox"
                          name="START DATE"
                          // selected={values.startDateTime}
                          style={{ border: '1px solid #eaedf3' }}
                          selected={values.startDateTime}
                          onChange={e => {
                            setFieldValue('startDateTime', e)
                          }}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy HH:mm"
                          timeCaption="Time"
                          onBlur={handleBlur}
                          autoComplete="off"
                          // minTime={moment()
                          //   .subtract(15, 'minutes')
                          //   .toDate()}
                          // maxTime={moment().toDate()}
                        />
                        <ErrorMessage
                          name="startDateTime"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </div>

                    <div>
                      <FormInputGroup>
                        <div style={{ marginBottom: '0.5rem' }}>
                          <span className="content-title">END DATE</span>
                        </div>
                        <StyledDatePicker
                          selectsStart
                          className="uik-input__input fullWidthInputBox"
                          name="END DATE"
                          // selected={values.startDateTime}
                          style={{ border: '1px solid #eaedf3' }}
                          selected={values.endDateTime}
                          onChange={e => {
                            setFieldValue('endDateTime', e)
                          }}
                          showTimeSelect
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy HH:mm"
                          timeCaption="Time"
                          onBlur={handleBlur}
                          autoComplete="off"
                          minTime={moment(values.startDateTime)
                            .add(15, 'minutes')
                            .toDate()}
                          maxTime={moment().toDate()}
                        />
                        <ErrorMessage
                          name="endDateTime"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </div>
                  </TopContainer>
                </MainContainer>
              )}

              {step === 1 && (
                <MainContainer>
                  <TopContainer>
                    {/* <FormInputGroup>
                      <HaulIdContainer>
                        <Select
                          name="company"
                          className="fullWidthSelectBox optionsFullWidth"
                          label="Company"
                          activeOption={values.companies}
                          options={[
                            {
                              value: '',
                              label: ''
                            }
                          ]}
                          onOptionClick={e => {
                            if (
                              values.companies &&
                              values.companies.find(item => item.value === e.value)
                            ) {
                              setFieldValue(
                                'companies',
                                values.companies.filter(item => item.value !== e.value)
                              )
                            } else {
                              setFieldValue('companies', [...values.companies, e])
                            }
                          }}
                          menuPosition="bottom-left"
                          multiple
                        />
                        <ErrorMessage
                          name="companies"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </HaulIdContainer>
                    </FormInputGroup> */}
                    <SelectWrapper>
                      <FormInputGroup>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          name="project"
                          label="Project"
                          activeOption={values.projects}
                          options={projectOptions}
                          menuPosition="bottom-left"
                          onOptionClick={e => handleProjectChange(e, setFieldValue, values)}
                          multiple
                        />
                        <ErrorMessage
                          name="project"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </SelectWrapper>

                    <SelectWrapper>
                      <FormInputGroup>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          name="haul"
                          label="Haul"
                          activeOption={values.hauls}
                          options={haulIdOptions}
                          // onOptionClick={e => handleHaulIdChange(e, setFieldValue, values)}
                          onOptionClick={e => {
                            if (values.hauls && values.hauls.find(item => item.value === e.value)) {
                              setFieldValue(
                                'hauls',
                                values.hauls.filter(item => item.value !== e.value)
                              )
                            } else {
                              setFieldValue('hauls', [...values.hauls, e])
                            }
                          }}
                          menuPosition="bottom-left"
                          multiple
                        />
                        <ErrorMessage
                          name="project"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </SelectWrapper>

                    <SelectWrapper>
                      <FormInputGroup>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          name="driver"
                          label="Driver"
                          activeOption={values.drivers}
                          options={driversList}
                          menuPosition="bottom-left"
                          onOptionClick={e => {
                            if (
                              values.drivers &&
                              values.drivers.find(item => item.value === e.value)
                            ) {
                              setFieldValue(
                                'drivers',
                                values.drivers.filter(item => item.value !== e.value)
                              )
                            } else {
                              setFieldValue('drivers', [...values.drivers, e])
                            }
                          }}
                          multiple
                        />
                        <ErrorMessage
                          name="project"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </FormInputGroup>
                    </SelectWrapper>
                  </TopContainer>
                </MainContainer>
              )}
            </StyledWidget>
            <FlexContainer>
              <ButtonWrapper>
                <ButtonContainer>
                  <ModalButton
                    name={step === 0 ? 'Cancel' : 'Back'}
                    onClick={handleBackOrCancelClick}
                  />
                </ButtonContainer>
                <ButtonContainer>
                  <ModalButton
                    success
                    backgroundcolor="#38B249"
                    disabled={isSubmitting}
                    name={step !== 1 ? 'Next' : 'Finish'}
                    onClick={() => handleNextButtonClick(values, errors, setFieldError)}
                  />
                </ButtonContainer>
              </ButtonWrapper>
            </FlexContainer>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default CreateReport

const DispatchSchema = Yup.object().shape({
  haulId: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  project: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  startDateTime: Yup.string()
})
